import { packageAiLimitsLines, type PackageAiLimitsLike } from '@proffer/shared'

type PackageAiLimitsSummaryProps = {
  limits: PackageAiLimitsLike
  /** Κλάση για χρώμα κουκκίδων (π.χ. tone dot από package presentation). */
  dotClassName?: string
  className?: string
  compact?: boolean
}

export function PackageAiLimitsSummary({
  limits,
  dotClassName = 'bg-violet-500',
  className = '',
  compact = false,
}: PackageAiLimitsSummaryProps) {
  const lines = packageAiLimitsLines(limits)

  return (
    <div
      className={`rounded-xl border border-zinc-200/80 bg-zinc-50/70 p-3 dark:border-zinc-700/80 dark:bg-zinc-950/40 ${className}`}
    >
      <p
        className={
          compact
            ? 'text-[0.65rem] font-bold uppercase tracking-[0.16em] text-zinc-500 dark:text-zinc-400'
            : 'text-xs font-bold uppercase tracking-[0.18em] text-zinc-600 dark:text-zinc-400'
        }
      >
        Όρια AI προσφορών
      </p>
      <ul
        className={`space-y-1.5 text-zinc-700 dark:text-zinc-300 ${
          compact ? 'mt-1.5 text-xs leading-relaxed' : 'mt-2 text-sm leading-relaxed'
        }`}
      >
        {lines.map((line) => (
          <li key={line} className="flex gap-2">
            <span
              className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${dotClassName}`}
              aria-hidden
            />
            <span>{line}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
